import { useContext } from 'react';
import { RecentBasketType } from '../../../../models/recent-basket-type';
import addToBasket from '../../../../services/content-api/endpoints/basket/recent/add';
import getBasket from '../../../../services/content-api/endpoints/basket/recent/get';
import updateRecentBasketId from '../actions/update-recent-basket-id';
import { BasketDispatchContext, BasketStateContext } from '../basket.provider';

const useAddToRecentBasket: () => (
  variantSku: string
) => Promise<void> = () => {
  const state = useContext(BasketStateContext);
  const dispatch = useContext(BasketDispatchContext);

  return async (variantSku: string) => {
    let basket: RecentBasketType;

    if (!state.recentId) {
      basket = await getBasket(state.recentId);
    }

    dispatch(updateRecentBasketId(basket?.basketId || state.recentId));

    addToBasket(basket?.basketId || state.recentId, variantSku);
  };
};

export default useAddToRecentBasket;
